/**
 * Browser-tab title helper: single place that resolves the brand so Arc
 * screens never show "Mosaico - X" (AR-578 follow-up). The brand follows the
 * same signal ArcDocumentBranding/app.tsx use: the `arc-branding` class on
 * <html> (live runtime state), with the cached Flipper flag in localStorage
 * as fallback for very early calls. Legacy stays byte-identical to the old
 * i18n template ("Mosaico - {{ page_name }}").
 */

const ARC_BRAND = 'ArcMosaico'
const LEGACY_BRAND = 'Mosaico'
/** Same key app.tsx writes when the arc-mosaico-project Flipper flag resolves */
const ARC_BRANDING_STORAGE_KEY = 'arc-branding-enabled'

/** Pure: builds "Brand - Page" (or just the brand without a page). */
export const formatDocumentTitle = (arcEnabled: boolean, page?: string): string => {
  const brand = arcEnabled ? ARC_BRAND : LEGACY_BRAND
  return page ? `${brand} - ${page}` : brand
}

/** Reads the arc branding signal (html class first, cached flag as fallback). */
export const isArcBrandingActive = (): boolean => {
  if (document.documentElement.classList.contains('arc-branding')) return true
  try {
    return window.localStorage.getItem(ARC_BRANDING_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

/** Sets the tab title with the right brand; without a page, brand only. */
export const setDocumentTitle = (page?: string): void => {
  document.title = formatDocumentTitle(isArcBrandingActive(), page)
}
